// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace Obsolescence {
  export type Pagination<T> = {
    readonly items: T[];
    readonly meta: {
      currentPage: number;
      itemCount: number;
      itemsPerPage: number;
      totalItems: number;
      totalPages: number;
    };
  };

  export type ObsolescenceComment = {
    readonly id: number;
    readonly content: string;
    readonly lastUpdateBy: string;
    readonly lastUpdateDate: string;
  };

  export enum Criticality {
    HIGH = 'high', // component date is outdated
    MEDIUM = 'medium', // component date is soon to be outdated (next 6 months)
    NONE = 'none',
  }

  export type ObsolescenceFlat = {
    readonly id: number;
    readonly lastUpdateBy: string;
    readonly lastUpdateDate: string;
    readonly date: Date;
    readonly criticality: Criticality;
    readonly source: Source;
    readonly comment: ObsolescenceComment;
    readonly reference: Reference;
  };

  export type ComponentFlat = {
    readonly componentRefId: number;
    readonly componentRefName: string;
    readonly componentRefType: string;
    readonly componentRefIsDetectedAtSG: boolean;
    readonly versionId: number | undefined;
    readonly versionName: string | undefined;
    readonly versionIsAStandardTechnology: boolean | undefined;
    readonly versionIsDetectedAtSG: boolean | undefined;
    readonly obsolescenceSource: Source | undefined;
    readonly obsolescenceSecuritySupport: ObsolescenceFlat | undefined;
    readonly obsolescenceActiveSupport: ObsolescenceFlat | undefined;
    readonly obsolescenceEndOfExtendedSupport: ObsolescenceFlat | undefined;
    readonly obsolescenceLifeCycleManagement: ObsolescenceFlat | undefined;
    readonly advisory: { uuid: string; version: string } | undefined;
  };

  export type Obsolescence = {
    readonly id: number;
    readonly source: Source;
    readonly reference: Reference;
    readonly date: Date;
    readonly comment: string;
    readonly versionId?: number;
  };

  export enum Reference {
    ACTIVE_SUPPORT = 'active-support',
    SECURITY_SUPPORT = 'security-support',
    END_OF_EXTENDED_SUPPORT = 'end-of-extended-support',
    LIFE_CYCLE_MANAGEMENT = 'life-cycle-management',
  }

  export enum Source {
    CUSTOM = 'custom',
    EOL = 'eol',
    REDCAT = 'redcat',
  }

  export type CreateCommentDTO = {
    content: string;
    obsolescenceId: number;
  };

  export type UpdateCommentDTO = Partial<Pick<CreateCommentDTO, 'content'>>;

  export type CreateObsolescenceDTO = {
    readonly source: Source;
    readonly reference: Reference;
    readonly date: string;
    readonly versionId: number;
  };

  export type UpdateObsolescenceDTO = Partial<Pick<CreateObsolescenceDTO, 'source' | 'reference' | 'date'>>;

  export type CreateAdvisoryDTO = {
    versionId: number;
    advisedVersionId: number;
  };

  export type UpdateAdvisoryDTO = Pick<CreateAdvisoryDTO, 'advisedVersionId'>;

  export type Advisory = {
    uuid: string;
    versionId: number;
    advisedVersionId: number;
  };

  export type ObsolescenceDateInfo = {
    date: string;
    lastUpdateBy: string;
    source: Source;
  };

  export type AdvisableVersion = {
    id: number;
    version: string;
    securitySupport: ObsolescenceDateInfo | null;
    activeSupport: ObsolescenceDateInfo | null;
    extendedSupport: ObsolescenceDateInfo | null;
    lifeCycleManagement: ObsolescenceDateInfo | null;
  };
}
